const normalizar = (url) => String(url || "").split(/[?#]/)[0].replace(/^\/+|\/+$/g, "");

const coletarPaginas = (itens, acumulado = []) => {
	(itens || []).forEach((item) => {
		if (item.page) acumulado.push(item.page);
		if (Array.isArray(item.submenu)) coletarPaginas(item.submenu, acumulado);
	});
	return acumulado;
};

const maisEspecifica = (paginas) =>
	paginas.reduce((melhor, pagina) =>
		melhor === null || normalizar(pagina).length > normalizar(melhor).length ? pagina : melhor, null);

export const encontrarPaginaAtiva = (itens, currentUrl) => {
	const url = normalizar(currentUrl);
	const paginas = coletarPaginas(itens);

	const porSegmento = paginas.filter((pagina) => {
		const alvo = normalizar(pagina);
		return url === alvo || url.startsWith(alvo + "/");
	});

	if (porSegmento.length > 0) return maisEspecifica(porSegmento);

	return maisEspecifica(paginas.filter((pagina) => url.indexOf(normalizar(pagina)) !== -1));
};
